import { QueryClient } from '@tanstack/react-query';

/**
 * Single shared QueryClient instance. Exported as a module singleton so non-React
 * code (e.g. DevAuthProvider, which is rendered outside QueryClientProvider) can
 * still call `queryClient.prefetchQuery(...)` to prime the cache.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      refetchOnWindowFocus: false,
      refetchInterval: false,
      retry: 1,
    },
  },
});
